import {
  gridExpandedSortedRowIdsSelector,
  gridRowSelectionCountSelector,
  gridRowSelectionManagerSelector,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from '@mui/x-data-grid-pro';

export const SelectAllVisibleHeaderCheckbox = () => {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const selectionCount = useGridSelector(apiRef, gridRowSelectionCountSelector);
  const visibleIds = useGridSelector(apiRef, gridExpandedSortedRowIdsSelector);
  const selectionManager = useGridSelector(apiRef, gridRowSelectionManagerSelector);

  const visibleSelectedCount = visibleIds.filter((id) => selectionManager.has(id)).length;
  const allVisibleSelected = visibleIds.length > 0 && visibleSelectedCount === visibleIds.length;
  const checked = selectionCount > 0 && allVisibleSelected;
  const indeterminate = selectionCount > 0 && !checked;

  const toggle = () => {
    if (selectionCount > 0) {
      apiRef.current.setRowSelectionModel({ type: 'include', ids: new Set() });
      return;
    }
    apiRef.current.setRowSelectionModel({
      type: 'include',
      ids: new Set(gridExpandedSortedRowIdsSelector(apiRef)),
    });
  };

  const BaseCheckbox = rootProps.slots.baseCheckbox;

  return (
    <BaseCheckbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={toggle}
      aria-label={apiRef.current.getLocaleText(
        checked || indeterminate
          ? 'checkboxSelectionUnselectAllRows'
          : 'checkboxSelectionSelectAllRows',
      )}
      {...rootProps.slotProps?.baseCheckbox}
    />
  );
};
